import React from 'react'
import E3_simple_on from '@e3dc-react/icons/icons/svgs/E3_simple_on.svg'
import E3_simple_off from '@e3dc-react/icons/icons/svgs/E3_simple_off.svg'
import { makeStyles } from 'tss-react/mui'
import { IconToggle } from 'src/Components/toggle'

interface StyleProps {
  checked: boolean
  svgIconOff: string
  svgIconOn: string
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  toggle: {
    height: 30,
    borderRadius: 8,
    padding: 0,

    '& .MuiSwitch-switchBase': {
      padding: 0,

      '&.Mui-checked': {
        transform: 'translateX(28px)',
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 6,
      backgroundColor: theme.palette.grey.grey07,
      border: `1px solid ${theme.palette.grey.grey06}`,

      '&::before, &::after': {
        backgroundColor: theme.palette.grey.grey00,
        width: 20,
        height: 20,
        maskSize: '20px 20px',
      },

      '&::before': {
        left: 6,
      },
      '&::after': {
        right: 6,
      },
    },
    '& .Mui-checked + .MuiSwitch-track': {
      background: theme.palette.grey.grey07,
    },
    '& .Mui-disabled': {
      '& .MuiSwitch-thumb': {
        opacity: 0.6,
      },

      '& + .MuiSwitch-track': {
        opacity: 0.6,
        background: theme.palette.grey.grey06,
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: props.checked ? theme.palette.primary.main : theme.palette.error.main,
      height: 24,
      width: 24,
      borderRadius: 6,
      position: 'relative',
      margin: 3,
      boxShadow: 'none',

      '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        backgroundColor: theme.palette.common.white,
        maskImage: `url(${props.checked ? props.svgIconOn : props.svgIconOff})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
      },
    },
  },
  root: {
    margin: 0,
  },
}))

interface Props {
  onChange: (event: unknown, checked: boolean) => void
  checked: boolean
  disabled?: boolean
}

/**
 * Toggle component to resemble an on/off switch
 */
const OnOffToggle: React.FC<Props> = ({ onChange, checked, disabled }) => {
  const { classes } = useStyles({ checked, svgIconOff: E3_simple_off, svgIconOn: E3_simple_on })

  return (
    <IconToggle
      checked={checked}
      svgIconOn={E3_simple_off}
      svgIconOff={E3_simple_on}
      onChange={onChange}
      className={classes.root}
      inputClassName={classes.toggle}
      disabled={disabled}
    />
  )
}

export default OnOffToggle
